"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategory = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const product_entity_1 = require("./product.entity");
let ProductCategory = class ProductCategory {
};
exports.ProductCategory = ProductCategory;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ProductCategory.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 120 }),
    tslib_1.__metadata("design:type", String)
], ProductCategory.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToMany)(() => product_entity_1.Product, (product) => product.categories),
    tslib_1.__metadata("design:type", Array)
], ProductCategory.prototype, "products", void 0);
exports.ProductCategory = ProductCategory = tslib_1.__decorate([
    (0, typeorm_1.Entity)('product_categories')
], ProductCategory);
